/* eslint-disable rxjs-x/finnish */
import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { Observable, distinctUntilChanged, map, merge } from 'rxjs';

import { Breakpoint, breakpoints } from '../../../../../breakpoints/config';
import { setBreakpoint } from './breakpoint.actions';

@Injectable()
export class BreakpointEffects {
  readonly #breakpointObserver = inject(BreakpointObserver);

  readonly #breakpointObservableMap: Record<
    Breakpoint,
    Observable<{
      breakpoint: Breakpoint;
      matched: boolean;
    }>
  > = {
    sm: this.#listenOnBreakpointChanges$('sm'),
    md: this.#listenOnBreakpointChanges$('md'),
    lg: this.#listenOnBreakpointChanges$('lg'),
    xl: this.#listenOnBreakpointChanges$('xl'),
    xxl: this.#listenOnBreakpointChanges$('xxl'),
  };

  public watchBreakpoints$ = createEffect(() =>
    merge(...Object.values(this.#breakpointObservableMap)).pipe(map(({ breakpoint, matched }) => setBreakpoint({ breakpoint, matched })))
  );

  #listenOnBreakpointChanges$(breakpoint: Breakpoint): Observable<{ breakpoint: Breakpoint; matched: boolean }> {
    return this.#isBreakpointActive$(breakpoint).pipe(
      map((matched) => ({
        breakpoint,
        matched,
      }))
    );
  }

  #isBreakpointActive$(breakpoint: Breakpoint): Observable<boolean> {
    return this.#breakpointObserver.observe(this.#getMediaQueryOfBreakpoint(breakpoint)).pipe(
      map((res) => res.matches),
      distinctUntilChanged()
    );
  }

  #getMediaQueryOfBreakpoint(breakpoint: Breakpoint): string {
    return `(min-width: ${breakpoints[breakpoint]}px)`;
  }
}
